import { inSectionFilter, SHOP_SECTION_FILTERS, type ShopSectionFilter } from "@alm/domain";
import type { ProductRow } from "@/routes/_authenticated/nancy/-components/graph/graph-model";

/* The picture narrowed to food or one kind of supplies. A kind and the products filed on it go by
   its section; a group stays when it is that section itself or holds a kind that is, but the
   products filed on the group alone go by the group's own section. */

export const parseShow = (value: unknown): ShopSectionFilter | null =>
  typeof value === "string" && (SHOP_SECTION_FILTERS as readonly string[]).includes(value)
    ? (value as ShopSectionFilter)
    : null;

/** The spreadsheet's rows the filter keeps. */
export const rowsIn = (rows: readonly ProductRow[], show: ShopSectionFilter | null) =>
  show ? rows.filter((row) => inSectionFilter(row.section, show)) : rows;
